import {
    GET_ALL_PRODUCTS,
    GET_ALL_ACTIVE_AUCTIONS,
    GET_SINGLE_PROJECT,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
} from './productTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_ALL_PRODUCTS:
            return {
                ...state,
                all_products: action.payload,
            }
        case GET_ALL_ACTIVE_AUCTIONS:
            return {
                ...state,
                activelots: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        case GET_SINGLE_PROJECT:
            return {
                ...state,
                single_project: action.payload,
            }
        default:
            return state
    }
}
